import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { getUsersToNotify, SurveysProvider } from '@modeso/aumico-lib-core-fe';
import { GetUserDto } from '@modeso/aumico-lib-users-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import cloneDeep from 'lodash/cloneDeep';
import { filter } from 'rxjs/operators';
import { SurveyPopupService } from './survey-popup.service';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class SurveyPollingService implements OnDestroy {
    private pollingInterval;
    private activeSurveyId: string | undefined;
    private currentUser: GetUserDto | undefined;

    constructor(
        private provider: SurveysProvider,
        public readonly dialog: MatDialog,
        private popupService: SurveyPopupService,
        private readonly actionsListener$: ActionsSubject,
    ) {
        this.actionsListener$
            .pipe(ofType(getUsersToNotify.getUsersToNotifySuccess), untilDestroyed(this))
            .subscribe((usersIds) => {
                if (usersIds.payload.includes(this.currentUser.id)) {
                    this.openFeedbackPopup();
                    this.provider.dispatchMarkUserAsNotified$(this.activeSurveyId);
                }
            });
    }

    startPolling(user: GetUserDto) {
        this.currentUser = cloneDeep(user);
        this.provider
            .getActiveSurvey$()
            .pipe(
                filter((survey) => survey != null),
                untilDestroyed(this),
            )
            .subscribe((survey) => {
                this.activeSurveyId = survey.id;
                this.provider.dispatchGetUsersToNotify$(survey.id);
            });

        // Check immediately when the app loads
        this.checkForActiveSurvey();

        // Set up periodic checking every 30 minutes instead of 10 seconds
        this.pollingInterval = setInterval(() => {
            this.checkForActiveSurvey();
        }, 30 * 60 * 1000); // 30 minutes in milliseconds
    }

    private checkForActiveSurvey() {
        this.provider.dispatchGetActiveSurvey();
    }

    ngOnDestroy() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }
    }

    private openFeedbackPopup(): void {
        this.popupService.openPopup();
    }
}
